import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnInit {
	loading: boolean = false;
	private bypassPaths = ['/login', '/forgotpassword', '/firsttimelogin', '/resetpwd'];
	private currentPath = '';

	constructor(private loaderService: LoaderService, private router: Router) {
		// Subscribe to router events to track the current path
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			this.currentPath = event.urlAfterRedirects; // Update the current path
		});

		// Subscribe to the loading state only if the current path is not in bypassPaths
		this.loaderService.isLoading.subscribe((v) => {
			if (!this.bypassPaths.some((path) => this.currentPath.includes(path))) {
				this.loading = v;
			}
		});
	}

	ngOnInit(): void {
		this.loading = false;
	}
}
